import { CircleButton } from 'component/Button/CircleButton'
import { Loader } from 'component/Loader'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useBodyScrollLock } from 'hook/useBodyScrollLock'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { useState } from 'react'
import css from './Doc.module.scss'

export const Doc = observer(() => {
  const demo = useDemo()
  const welcome = demo.welcome!
  const { doc } = welcome
  const [ready, setReady] = useState(false)

  useBodyScrollLock(true)

  const onLoad = useLatestCallback((e: any) => {
    setReady(true)
  })

  const onClose = useLatestCallback(() => {
    welcome.doc = null
  })

  return <Vertical className={css.doc}>
    <iframe className={css.frame} src={`${doc!}#toolbar=0`} onLoad={onLoad} />
    {!ready && <Space className={css.load}>
      <Loader />
    </Space>}
    <Space pin={[16, 16, null, null]}>
      <CircleButton size={64} onClick={onClose}>
        <Icon size={32} name="close" />
      </CircleButton>
    </Space>
  </Vertical>
})
